//import { basename } from "path";
import moment from 'moment';
export default {
    data: () => ({
        formRef: 'formRef',
        rules: {
            required: value => {
                if (!value) return 'Обязательное поле'; // typeof null === object

                switch (typeof value) {
                    case 'number':
                        return true;
                    case 'boolean':
                        return value || 'Обязательное поле';
                    case 'object':
                        return Array.isArray(value) ? !!value.length || 'Обязательное поле' : !!Object.entries(value).length || 'Обязательное поле';
                    default:
                        return (!!value && value.trim().length > 0) || 'Обязательное поле';
                }
            },
            stringLengthMaxMin: (max, min = 0) => value => {
                // if ( !value ) return

                if (max && value.trim().length > max) {
                    return `Максимальное количество символов: ${max}`;
                } else if (min && value && value.trim().length < min) {
                    return `Минимальное количество символов: ${max}`;
                }
                return true;
            },
            counter: value => value.length <= 20 || 'Max 20 characters',
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || 'Некорректный e-mail.';
            },
            bin: value => {
                return (value + '').length == 12 || 'Некорректный БИН';
            }
        }
    }),
    methods: {
        validateForm() {
            //!!во всех компонентах которые используют этот примесь нужно в компоненте указать formRef-ссылка на контейнер формы
            return this.$refs[this.formRef].validate();
        },
        PasswordRequired: function(val) {
            if (val) {
                return true;
            } else {
                return this.$t('Введите пароль');
            }
        },
        minLengthOfPassword: function(val) {
            return val.length < 8 ? this.$t('Минимум 8 символов') : true;
        },
        checkStatusDate: function(DateFrom, DateUntil, hasError) {
            // this.hasError = false;
            if (DateFrom && DateUntil) {
                if (moment(DateFrom).isAfter(DateUntil)) {
                    this.hasError = true;
                    return this.$t("'Дата по' не может быть раньше 'Дата с'");
                } else {
                    this.hasError = false;
                    return true;
                }
            } else {
                this.hasError = false;
                return true;
            }
        },
        phoneFormatRule: function(value) {
            if (!value) return true;
            const MIN_PHONE_LENGTH = 9;

            return (
                value.replace(/(_)/g, '').length < 4 ||
                (value && !value.includes('_') && value.length > MIN_PHONE_LENGTH) ||
                this.$t('Введите корректный номер телефона')
            );
        }
    },
    computed: {
        emailRules: function(val) {
            if (!val) return false;
            return [
                v => !!v || this.$t('Введите E-mail'),
                v =>
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                        v
                    ) || this.$t('Формат введенного E-mail неверный. Пример «a@a.a»')
            ];
        },
        emailRules2: function(val) {
            if (!val) return false;
            return [
                v => !!v || this.$t('Обязательное поле'),
                v =>
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                        v
                    ) || this.$t('Формат введенного E-mail неверный. Пример «a@a.a»')
            ];
        },
        passwordRequirments: function(v) {
            return [
                v => (!!v && v.length >= 10) || this.$t('Длина пароля должна быть не менее 10 символов'),
                v =>
                    /^(^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!~^%*)_+(#}{|'";:/.,><?&])[A-Za-z\d@$!~^)_+(%*#}{|'";:/.,><?&]{10,}$)$/.test(v) ||
                    this.$t('В числе символов пароля обязательно должны присутствовать буквы, цифры и специальные символы (@, #, $, &, *, % и т.п.)')
            ];
        }
        //   min: v => v.length >= 8 || "Минимум 8 символов"
    }
};
